import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  schemaFieldsSelector,
  derivedSamplesSelector,
  fieldToggled,
  dataTypeChanged,
  fieldNameChanged
} from 'redux/schemaSlice';
import useWizardNavigation from 'hooks/useWizardNavigation';

import NavigationButtons from 'components/NavigationButtons';
import FormatSettings from 'components/FormatSettings';

import {
  DataGridBody,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridHeaderRow,
  DataGridRow
} from 'components/DataGrid';

import {
  StyledTable,
  StyledCheckboxHeaderCell,
  CheckboxCell,
  FieldTypeCell,
  StyledCalciteSelect,
  FieldNameCell,
  SampleCell,
  StyledMapperTableTextField
} from './ConfirmSchemaStep-styled';

import { CalciteCheckbox, CalciteOption } from 'components/Calcite';

const ConfirmSchemaStep: React.FC = () => {
  const dispatch = useDispatch();
  const schemaFields = useSelector(schemaFieldsSelector);
  const samples = useSelector(derivedSamplesSelector);
  const { previous, next } = useWizardNavigation();

  return (
    <>
      <FormatSettings />
      <StyledTable>
        <DataGridHeader>
          <DataGridHeaderRow>
            <StyledCheckboxHeaderCell></StyledCheckboxHeaderCell>
            <DataGridHeaderCell>Field Type</DataGridHeaderCell>
            <DataGridHeaderCell>Field Name</DataGridHeaderCell>
            <DataGridHeaderCell>Sampled Values</DataGridHeaderCell>
          </DataGridHeaderRow>
        </DataGridHeader>
        <DataGridBody>
          {Object.entries(schemaFields).map(
            ([key, { mapped, dataType, toName }]) => (
              <DataGridRow key={key}>
                <CheckboxCell>
                  <CalciteCheckbox
                    checked={mapped}
                    onChange={() => dispatch(fieldToggled(key))}
                  />
                </CheckboxCell>
                <FieldTypeCell>
                  <StyledCalciteSelect
                    label="datatype"
                    value={dataType}
                    onChange={value =>
                      dispatch(
                        dataTypeChanged({
                          dataType: value as DataType,
                          fieldName: key
                        })
                      )
                    }
                  >
                    <CalciteOption
                      key="Boolean"
                      selected={dataType === 'Boolean'}
                      value="Boolean"
                    >
                      Boolean
                    </CalciteOption>
                    <CalciteOption
                      key="Date"
                      selected={dataType === 'Date'}
                      value="Date"
                    >
                      Date
                    </CalciteOption>
                    <CalciteOption
                      key="Float32"
                      selected={dataType === 'Float32'}
                      value="Float32"
                    >
                      Float32
                    </CalciteOption>
                    <CalciteOption
                      key="Float64"
                      selected={dataType === 'Float64'}
                      value="Float64"
                    >
                      Float64
                    </CalciteOption>
                    <CalciteOption
                      key="Int32"
                      selected={dataType === 'Int32'}
                      value="Int32"
                    >
                      Int32
                    </CalciteOption>
                    <CalciteOption
                      key="Int64"
                      selected={dataType === 'Int64'}
                      value="Int64"
                    >
                      Int64
                    </CalciteOption>
                    <CalciteOption
                      key="String"
                      selected={dataType === 'String'}
                      value="String"
                    >
                      String
                    </CalciteOption>
                  </StyledCalciteSelect>
                </FieldTypeCell>
                <FieldNameCell>
                  <StyledMapperTableTextField
                    value={toName || key}
                    onChange={value =>
                      dispatch(
                        fieldNameChanged({
                          newName: value,
                          fieldName: key
                        })
                      )
                    }
                  />
                </FieldNameCell>
                <SampleCell>{String(samples[0].attributes[key])}</SampleCell>
              </DataGridRow>
            )
          )}
        </DataGridBody>
      </StyledTable>
      <NavigationButtons
        onPrevious={previous}
        onNext={next}
      ></NavigationButtons>
    </>
  );
};

export default ConfirmSchemaStep;
